import { CostCenter } from './cost-center';
import { Supplier } from './supplier';
 export class EnterVoWD{
    AccrualID!: Number;
    SupplierAB! :Number;
    CostCenter!: string;
    ContractId!: string;
    ContractAmount !: number;
    ContractDecscription!: string;
    ContractIdentity!: Number;
    ObjectAccount!: string;
    Period!: string;
    DivisionField!: String;
    VOWDAmount ?: Number;
    CurrencyType!: String;
    DescrOfWork!: String;
    CreatedDate ?: Date;
    CreatedBy!: String;
    UpdatedDate : Date|undefined|null;
    UpdatedBy!: String;
    IsActive ? : Boolean;
    IsSave ? : Boolean;
    IsSubmitted ? : Boolean;
    MstCostCenter: CostCenter|undefined|null;
    MstSupplier: Supplier|undefined|null;
    Invoice ?:Number;
    JDE_Actual_Amount ?:Number;
     Adjustment ?:Number;
     Drops ?:Number;
     Overpayments ?:Number;
     Accrual ?:Number;
     DueDate ?:Date;
     OnBehalf!: String;
}